module.exports = __webpack_public_path__ + "static/img/21-0623-detail2.c52c85f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/21-0623-detail2.jpg
// module id = fEAS
// module chunks = 0